import { ref } from "vue";
import { router } from '@inertiajs/vue3';
import { defineStore } from "pinia";

export const useNavegacaoStore = defineStore('navegacao', () => {
    const HOME_URL = '/home';

    const isInitialized = ref(false);

    const previousUrls = ref([]);

    const init = () => {
        if (isInitialized.value) return;

        router.on('navigate', (event) => {
            const url = event.detail?.page?.url;

            const last = previousUrls.value.at(-1);

            if (url && url !== last) previousUrls.value.push(url);
        });

        isInitialized.value = true;
    }

    const goBack = () => {
        const previous = getPreviousUrl();

        updateHistory();

        if (previous) {
            router.visit(previous);
        } else {
            router.visit(HOME_URL);
        }
    }

    const getPreviousUrl = () => {
        if (previousUrls.value.length < 2) return null;

        return previousUrls.value.at(-2);
    }

    const updateHistory = () => {
        previousUrls.value.pop();
        previousUrls.value.pop();
    }

    return {
        init,
        goBack
    }
});
